import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  addLinkService,
  // removeLinkService,
} from "../../../../services/myProject.services";
import ToastContent from "../../../components/toast/toast";
import { Check } from "react-feather";
import toast from "react-hot-toast";
import { getErrorMsg } from "../../../../common/ErrorMessages/errorMessage";

const AddLink = ({ openModel, setOpenModel, modalSize, getProjectList }) => {
  const [disabledButton, setHandleDisabledBtn] = useState(false);
  const defaultValues = {
    link: openModel?.type === "add" ? "" : openModel?.review_link,
  };

  const schema = yup.object().shape({
    link: yup
      .string()
      .when("required", {
        is: "add",
        then: yup
          .string()
          .url()
          .max(500, "The link should not exceed 500 characters")
          .required("Link is Required")
          .typeError("Link is Required"),
        otherwise: yup
          .string()
          .url()
          .max(500, "The link should not exceed 500 characters")
          .nullable(),
      })
      .nullable(),
  });
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const resetForm = () => {
    reset();
    setOpenModel(false);
  };

  const onSubmit = (e) => {
    const sendValue = {
      is_edit: e.is_edit,
      link: e.link.trim() === "" ? null : e.link,
      id: openModel.id,
    };
    setHandleDisabledBtn(true);
    addLinkService(sendValue)
      .then((data) => {
        toast((t) => (
          <ToastContent
            t={t.id}
            message={data?.message}
            icon={<Check size={12} />}
          />
        ));
        getProjectList();
        resetForm();
      })
      .catch((err) => {
        getErrorMsg(err);
      })
      .finally(() => {
        setHandleDisabledBtn(false);
      });
  };

  // const handleRemoveLink = () => {
  //   reset({
  //     link: "",
  //   });
  //   setHandleDisabledBtn(true);
  //   removeLinkService({ id: openModel.id })
  //     .then((data) => {
  //       toast((t) => (
  //         <ToastContent
  //           t={t.id}
  //           message={data?.message}
  //           icon={<Check size={12} />}
  //         />
  //       ));
  //       getProjectList();
  //       resetForm();
  //     })
  //     .catch((err) => {
  //       getErrorMsg(err);
  //     })
  //     .finally(() => {
  //       setHandleDisabledBtn(false);
  //     });
  // };
  useEffect(() => {
    reset({
      link: openModel?.type === "add" ? "" : openModel?.review_link,
      is_edit: openModel?.type === "add" ? 0 : 1,
      required: openModel?.type,
    });
  }, [openModel]);

  return (
    <Modal
      isOpen={openModel ? true : null}
      toggle={() => setOpenModel(!openModel)}
      className={`modal-dialog-centered ${modalSize ? modalSize : ""}`}
      onClosed={() => reset()}
    >
      <ModalHeader
        className="bg-transparent"
        toggle={() => setOpenModel(!openModel)}
      ></ModalHeader>
      <ModalBody>
        <h1 className="text-center mb-1">
          {openModel?.type === "add" ? "Add" : "Edit"} Review Link
        </h1>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="gy-1 gx-2 mt-75 mb-75">
            <Col xl={12} md={12} sm={12} xxl={12}>
              <Label className="form-label" for="reviewLink">
                {openModel?.type === "add" ? "Add" : "Edit"} Review Link
              </Label>
              <Controller
                name="link"
                id="link"
                control={control}
                render={({ field }) => (
                  <Input
                    // value={}
                    type="text"
                    // placeholder={`${
                    //   openModel?.type === "add" ? "Add" : "Edit"
                    // } Review Link`}
                    placeholder="https://frame.io/"
                    name="link"
                    {...field}
                  />
                )}
              />
            </Col>
            <FormFeedback>{errors?.link?.message}</FormFeedback>
            <Col className="text-center mt-2" xs={12}>
              <Button
                disabled={disabledButton}
                type="submit"
                color="primary"
                className="me-2"
                // onClick={() => stepper.next()}
              >
                Submit
              </Button>
              {/* <Button
                disabled={disabledButton}
                color="primary"
                className="me-2 d-none"
                onClick={() => handleRemoveLink()}
              >
                Remove Link
              </Button> */}
              <Button color="secondary" outline onClick={() => resetForm()}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AddLink;
